<template>
  <footer class="app-footer">
    <div class="footer-contents">
      <ul class="bom-link clearfix">
        <li>
          <a
            href="http://www.cebpubservice.com/low/platform/index.shtml?20151216153242"
            target="_blank"
            rel="noopener noreferrer"
          >平台简介</a><span class="sep">|</span>
        </li>
        <li>
          <a
            href="http://www.cebpubservice.com/low/us/index.shtml?20151216153242"
            target="_blank"
            rel="noopener noreferrer"
          >联系我们</a><span class="sep">|</span>
        </li>
        <li>
          <a
            href="http://www.cebpubservice.com/low/copyrights/index.shtml?20151216153242"
            target="_blank"
            rel="noopener noreferrer"
          >版权声明</a><span class="sep">|</span>
        </li>
        <li
          class="weixin-trigger"
          @mouseenter="showWeixin = true"
          @mouseleave="showWeixin = false"
        >
          <a href="javascript:void(0)" @click.prevent="showWeixin = !showWeixin">平台公众号</a>
          <div
            v-show="showWeixin"
            class="weixin-popup"
            @mouseenter="showWeixin = true"
            @mouseleave="showWeixin = false"
          >
            <img
              src="https://bulletin.cebpubservice.com/resource/ceb/images/weixin.jpg"
              alt="平台公众号二维码"
              width="96"
              height="96"
            >
          </div>
        </li>
      </ul>

      <div class="ft">
        <p>
          <a
            class="beian-link"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020185"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://bulletin.cebpubservice.com/resource/ceb/images/ghs.png"
              alt=""
              class="beian-icon"
            >
            <span>京公网安备 11010802020185号</span>
          </a>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备15011138号</a>
          <span class="copyright">版权所有：中国招标公共服务平台有限公司</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      showWeixin: false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  width: 100%;
  color: #000;
  font-size: 12px;
  line-height: 1.5;
  padding: 30px 30px;
}

.footer-contents {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px 24px;
  text-align: center;
}

.bom-link {
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  li {
    display: inline-flex;
    align-items: center;
  }

  a {
    color: #000;
    text-decoration: none;
    padding: 0 6px;
    transition: color 0.2s;

    &:hover {
      color: #000;
    }
  }

  .sep {
    color: #000;
    user-select: none;
  }

  .weixin-trigger {
    position: relative;
    cursor: pointer;
  }
}

.ft {
  p {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 8px 12px;
    line-height: 20px;
  }

  a {
    color: #000;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    transition: color 0.2s;

    &:hover {
      color: #000;
    }
  }

  .beian-link {
    height: 20px;
    line-height: 20px;
  }

  .beian-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .copyright {
    color: #000;
  }
}

.weixin-popup {
  position: absolute;
  left: 100%;
  margin-left: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  padding: 6px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);

  img {
    display: block;
  }
}

.clearfix::after {
  content: '';
  display: table;
  clear: both;
}

@media (max-width: 768px) {
  .footer-contents {
    padding: 16px 12px 20px;
  }

  .bom-link a {
    padding: 4px;
    font-size: 12px;
  }

  .ft p {
    flex-direction: column;
    gap: 6px;
    font-size: 11px;
    line-height: 1.6;
  }

  .bom-link .weixin-trigger .weixin-popup {
    left: 50%;
    margin-left: 0;
    top: auto;
    bottom: 100%;
    margin-bottom: 8px;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 480px) {
  .bom-link .sep {
    display: none;
  }

  .bom-link li {
    width: 50%;
    justify-content: center;
    box-sizing: border-box;
    padding: 4px 0;

    &:nth-child(odd) {
      border-right: 1px solid #555;
    }
  }
}
</style>
